export function HiddenMarkup() {
    return <div
        dangerouslySetInnerHTML={{__html: "<!-- this component actually hides the overview or visa reqs which is extracted in for example _visa_requirements or _overview.[lang].md -->"}}/>;
}
